import {
  safeLocalStorageGetItem,
  safeLocalStorageSetItem,
} from "@/util/safeLocalStorage";
import { makeAutoObservable } from "mobx";

const STORAGE_KEY = "vidmuse_unseen_version_ids";
const PENDING_TASKS_KEY = "vidmuse_pending_task_ids";

class UnseenVersionStore {
  /**
   * 记录所有未读的版本 ID
   */
  unseenVersionIds: Set<string> = new Set();

  /**
   * 记录正在生成的 Task ID（用于在 Task 完成后识别它是新生成的）
   */
  pendingTaskIds: Set<string> = new Set();

  constructor() {
    makeAutoObservable(this);
    this.load();
  }

  private load() {
    const stored = safeLocalStorageGetItem(STORAGE_KEY);
    if (stored) {
      try {
        const ids = JSON.parse(stored);
        if (Array.isArray(ids)) {
          this.unseenVersionIds = new Set(ids);
        }
      } catch (e) {
        console.error("Failed to parse unseen version IDs", e);
      }
    }

    const storedPending = safeLocalStorageGetItem(PENDING_TASKS_KEY);
    if (storedPending) {
      try {
        const ids = JSON.parse(storedPending);
        if (Array.isArray(ids)) {
          this.pendingTaskIds = new Set(ids);
        }
      } catch (e) {
        console.error("Failed to parse pending task IDs", e);
      }
    }
  }

  private persist() {
    safeLocalStorageSetItem(
      STORAGE_KEY,
      JSON.stringify(Array.from(this.unseenVersionIds))
    );
    safeLocalStorageSetItem(
      PENDING_TASKS_KEY,
      JSON.stringify(Array.from(this.pendingTaskIds))
    );
  }

  addUnseenVersion(versionId: string) {
    if (this.unseenVersionIds.has(versionId)) return;
    this.unseenVersionIds.add(versionId);
    this.persist();
  }

  markAsSeen(versionId: string) {
    if (!this.unseenVersionIds.has(versionId)) return;
    this.unseenVersionIds.delete(versionId);
    this.persist();
  }

  isUnseen(versionId: string) {
    return this.unseenVersionIds.has(versionId);
  }

  addPendingTaskId(taskId: string) {
    this.pendingTaskIds.add(taskId);
    this.persist();
  }

  removePendingTaskId(taskId: string) {
    this.pendingTaskIds.delete(taskId);
    this.persist();
  }

  isPendingTask(taskId: string) {
    return this.pendingTaskIds.has(taskId);
  }
}

export const unseenVersionStore = new UnseenVersionStore();
